export function nativeHlsSupported(video) {
    return video.canPlayType("application/vnd.apple.mpegurl") !== "";
}
export function streamPreviewVerdict(resource, hasNativeHls) {
    if (!resource.url.trim())
        return { playable: false, reason: "no_url" };
    if (resource.isEncrypted)
        return { playable: false, reason: "encrypted" };
    switch (resource.protocol) {
        case "hls":
            return hasNativeHls
                ? { playable: true, via: "native" }
                : { playable: true, via: "hls.js" };
        case "dash":
            return { playable: false, reason: "no_dash_player" };
        case "other":
            return { playable: false, reason: "protocol_unknown" };
    }
}
export function preferredPreviewResource(resources, hasNativeHls) {
    var _a, _b;
    if (resources.length === 0)
        return null;
    const playable = resources.filter((r) => streamPreviewVerdict(r, hasNativeHls).playable);
    return ((_b = (_a = playable.find((r) => r.protocol === "hls")) !== null && _a !== void 0 ? _a : playable[0]) !== null && _b !== void 0 ? _b : resources[0]);
}
export function hlsSiblingUrl(resources) {
    const sibling = resources.find((r) => r.protocol === "hls" && !r.isEncrypted && r.url.trim());
    return sibling ? sibling.url : null;
}
export const PREVIEW_PROTOCOL_LABELS = {
    hls: "HLS",
    dash: "DASH",
    other: "Unknown",
};
